export default __webpack_public_path__ + "static/media/logo-w-lts-badge-grayed.eff1b32a.svg";